import {
  type MaintenanceOption,
  type PastMaintenance,
  type ReminderPrefill,
  type WebData,
  webDataError,
  webDataFetching,
  webDataNotAsked,
  webDataSuccess,
} from '@cobliteam/api-lib';
import { type Draft, produce } from 'immer';
import type { Reducer } from 'redux';
import type { PastMaintenancesAction } from './actions';
import { ActionTypes } from './actionTypes';

export interface RegisterMaintenanceState {
  editMaintenance?: PastMaintenance;
  reminderPrefill?: ReminderPrefill;
  maintenanceItemOptionsWebData: WebData<MaintenanceOption[]>;
}

export const registerMaintenanceStateInitialState: RegisterMaintenanceState = {
  editMaintenance: undefined,
  reminderPrefill: undefined,
  maintenanceItemOptionsWebData: webDataNotAsked(),
};

export const registerMaintenanceReducer: Reducer<RegisterMaintenanceState, PastMaintenancesAction> = produce(
  (draft: Draft<RegisterMaintenanceState>, action: PastMaintenancesAction) => {
    switch (action.type) {
      case ActionTypes.LOAD_MAINTENANCE_ITEM_OPTIONS_REQUEST:
        draft.maintenanceItemOptionsWebData = webDataFetching();
        break;

      case ActionTypes.LOAD_MAINTENANCE_ITEM_OPTIONS_SUCCEEDED:
        draft.maintenanceItemOptionsWebData = webDataSuccess(action.payload);
        break;

      case ActionTypes.LOAD_MAINTENANCE_ITEM_OPTIONS_FAILED:
        draft.maintenanceItemOptionsWebData = webDataError();
        break;

      case ActionTypes.MARK_MAINTENANCE_AS_DONE_REQUEST:
        draft.editMaintenance = undefined;
        draft.reminderPrefill = action.payload;
        break;

      case ActionTypes.EDIT_MAINTENANCE_REQUEST:
        draft.editMaintenance = action.payload;
        draft.reminderPrefill = undefined;
        break;

      case ActionTypes.REGISTER_MAINTENANCE_REQUEST:
        draft.editMaintenance = undefined;
        draft.reminderPrefill = undefined;
        break;
    }
  },
  registerMaintenanceStateInitialState
);
